import React, { useEffect } from 'react'
import Box from '../../../../components/Box'
import { useLocation, useNavigate } from 'react-router'

function ViewTab() {
  const navigate = useNavigate()
  const location = useLocation()

  const currentPath = location.pathname
  const selectedSegment = currentPath.includes('viewer_access') ? 'access' : 'create'

  const handleSegmentChange = (segment) => {
    if (segment === 'create') {
      navigate('/user/mosque_view')
    } else {
      navigate('/user/viewer_access')
    }
  }

  return (
    <div style={{ display:'flex', justifyContent:'flex-end'}}>
      <Box display="flex" alignItems="center" cursor="pointer" justifyContent="space-between" paddingLeft="1.1rem" paddingRight="1.1rem">
        <ul className="d-flex plan-modal ">
          <li
            className="information col-6 d-flex justify-content-center align-items-center"
            style={{
              fontWeight: "600",
              backgroundColor: selectedSegment === "create" ? "#D0004B" : "#fff",
              color: selectedSegment === "create" ? "#fff" : "#D0004B",
              borderRadius: "50px 0px 0px 50px",
            }}
            onClick={() => handleSegmentChange("create")}
          >
            Create Account
          </li>
          <li
            className="screen-details col-6 pt-2 d-flex justify-content-center align-items-center"
            style={{
              fontWeight: "600",
              backgroundColor: selectedSegment === "access" ? "#D0004B" : "#fff",
              color: selectedSegment === "access" ? "#fff" : "#D0004B",
              borderRadius: "0px 50px 50px 0px",
            }}
            onClick={() => handleSegmentChange("access")}
          >
            Viewer Access
          </li>
        </ul>
      </Box>
    </div>
  )
}

export default ViewTab
